import React, {useRef, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {exportCsvFile, importCsvFile} from "../../store/import-export-slice";
import BaseModal from "../common/modal/BaseModal";
import Icon from "../ui/Icon";
import Button from "../common/button/Button";
import AlertMessage from "../ui/AlertMessage";

function ImportExportButton({ttid, listName}) {
    const dispatch = useDispatch();
    const fileInputRef = useRef(null);
    const [selectedFile, setSelectedFile] = useState(null);
    const [isOpen, setIsOpen] = React.useState(false);
    const [alertInfo, setAlertInfo] = useState(null);

    const userRole = useSelector((state) => state.auth.selectedRole);

    // 📄 File selected
    const handleFileChange = (e) => {
        setSelectedFile(e.target.files[0]);
    };

    const handleSelectFile = () => {
        fileInputRef.current.click();
    };

    const showAlert = (message, variant = 'info') => {
        setAlertInfo({message, variant});
    };

    // Export CSV handler
    const handleExport = async () => {
        try {
            const response = await dispatch(exportCsvFile({...userRole, ttid})).unwrap();
            const csvContent = response?.data;

            if (response.status !== 200) {
                showAlert(response.data.message, 'danger');
                return;
            }

            // Create Blob and download
            const blob = new Blob([csvContent], {type: "text/csv;charset=utf-8;"});
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = `${listName}_products_export`;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            window.URL.revokeObjectURL(url);
        } catch (err) {
            showAlert(err || 'Failed to export CSV', 'info');
        }
    };

    //Import CSV handler
    const handleImport = async () => {
        const formData = new FormData();
        formData.append("file", selectedFile);

        try {
            const response = await dispatch(importCsvFile({...userRole, data: formData})).unwrap();

            if (response?.status === 200) {
                showAlert('Import successful', 'success');
                setSelectedFile(null);
                setTimeout(() => {
                    window.location.reload();
                }, 1000); // optional delay to let alert show briefly
            } else {
                showAlert(response.data.message, 'danger');
            }
        } catch (err) {
            showAlert(err || 'Import failed', 'danger');
        }
        setSelectedFile(null);
        setIsOpen(false);
    };

    return (
        <>
            {/* Import Export Buttons*/}
            <Button onClick={() => setIsOpen(true)} className="btn-sm">
                <Icon name="download" width="20" height="20"></Icon>
                Import
            </Button>
            <Button className="btn-sm" onClick={handleExport}>
                <Icon name="upload" width="20" height="20"></Icon>
                Export
            </Button>

            {/*Modal*/}
            <BaseModal isOpen={isOpen}>
                <div className="modal-body p-5 mb-n2">
                    <h5 className="modal-title mb-4">Import CSV</h5>
                    <div className="mb-3">
                        {/*To display the name of the file*/}
                        <span className="ms-3">{selectedFile?.name || "No file chosen"}</span>
                    </div>
                    <button className="btn btn-sm bg-secondary bg-opacity-25 bg-opacity-50-hover mt-2"
                            onClick={handleSelectFile}>
                        Choose File
                    </button>
                    <input
                        type="file"
                        accept=".csv"
                        ref={fileInputRef}
                        style={{display: 'none'}}
                        onChange={handleFileChange}
                    />
                </div>
                <div className="modal-footer">
                    <button type="button"
                            className="btn bg-secondary btn-md bg-opacity-25 bg-opacity-50-hover fw-medium border-0"
                            onClick={() => {
                                setIsOpen(false);
                                setSelectedFile(null)
                            }}
                    >
                        Cancel
                    </button>
                    <button type="button"
                            className="btn btn-md bg-primary bg-opacity-50 fw-medium border-0"
                            disabled={!selectedFile}
                            onClick={handleImport}
                    >
                        Import
                    </button>
                </div>
            </BaseModal>

            {/*Alert*/}
            {alertInfo && (
                <AlertMessage
                    message={alertInfo.message}
                    variant={alertInfo.variant}
                    duration={2000}
                    onClose={() => setAlertInfo(null)}
                />
            )}
        </>
    );
}

export default ImportExportButton;
